module.exports = __webpack_public_path__ + "images/icon-48.611ac91fcd09b07e72e7dc4fcec208bd.png";